/**
 * Offset handed to KeyboardAvoidingView's `keyboardVerticalOffset`. Always 0 now.
 *
 * KeyboardAvoidingView derives its padding from its OWN measured frame:
 *   keyboardY = keyboardFrame.screenY - keyboardVerticalOffset
 *   bottom    = frame.y + frame.height - keyboardY
 * (react-native/Libraries/Components/Keyboard/KeyboardAvoidingView.js). So the offset
 * ADDS padding: every point of it is a point of form the user no longer sees.
 *
 * iOS: the header is already inside the measured frame, so adding its height on top
 * double-counted it and padded ~170px more than the keyboard needs -- the login form was
 * squeezed to barely one field tall and the forget-password buttons went under the
 * keyboard. Measured on device: with the old offset the Login button sat at y=309-361
 * with the keyboard top at ~533; with 0 it sits just above the keyboard.
 *
 * Android used to need `headerHeight + StatusBar.currentHeight` for a real reason: the
 * app window started BELOW the status bar, so the frame (window coordinates) and the
 * keyboard (screen coordinates) were offset from each other by exactly that much. Since
 * the Expo SDK 54 hop the Android build is edge-to-edge and the window spans the whole
 * screen -- verified on an API 36 device, where RN reports `isEdgeToEdge: true` and
 * window height == screen height == 2400px. The two coordinate spaces are now the same,
 * so the compensation became pure over-padding and squeezed the Android login form the
 * same way it used to squeeze the iOS one.
 *
 * Kept as a hook rather than deleted at the call sites: the fact that the correct offset
 * is 0 is not obvious, and it has now been got wrong once per platform.
 */
export const useVerticalOffsetHeight = (): number => 0;
